export default __webpack_public_path__ + "static/media/logoimg1.ceeb58b0.png";